var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "payment",
      attrs: { id: "warehouse-registered-payment-method-page" }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "payment-content" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "m-b-xl" }, [
          _vm._v(
            "\n      月毎のご利用料は、ご登録頂いたお支払い方法にて決済させていただきます。\n    "
          )
        ]),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "box-link-to-warehouse m-b-lg" },
          [
            _c(
              "router-link",
              {
                staticClass: "link-to-warehouse",
                attrs: { to: "/Warehouses" }
              },
              [_vm._v("倉庫管理はこちら")]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("h1", { staticClass: "payment-title" }, [
        _vm._v("お支払い方法のご登録ありがとうございます。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-b-xl" }, [
      _vm._v("\n      お手続きありがとうございます。"),
      _c("br"),
      _vm._v("\n      倉庫をご利用いただく準備が整いました。\n    ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-b-xl" }, [
      _vm._v(
        "\n      尚、倉庫が利用可能となるまで、お時間を頂く場合があります。"
      ),
      _c("br"),
      _vm._v(
        "\n      倉庫管理画面にて 「利用中の倉庫」 に表示されない場合は、しばらくたってからご確認いただくようお願いいたします。\n    "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ffe43832", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffe43832","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouses/RegisteredPaymentMethod.vue
// module id = null
// module chunks = 